import { render, staticRenderFns } from "./templateConfig.vue?vue&type=template&id=20e25f56&scoped=true&"
import script from "./templateConfig.vue?vue&type=script&lang=js&"
export * from "./templateConfig.vue?vue&type=script&lang=js&"
import style0 from "./templateConfig.vue?vue&type=style&index=0&id=20e25f56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e25f56",
  null
  
)

export default component.exports